import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => {
  return {
    tooltip: {
      minWidth: 310
    }
  }
})
